var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09473 0.407227C7.92624 0.407227 7.76311 0.431643 7.60791 0.476408C8.02292 0.978762 8.27479 1.63508 8.27479 2.35379C8.27479 3.07251 8.02785 3.71549 7.62034 4.21603C7.77168 4.25854 7.93053 4.2816 8.09473 4.2816C9.10909 4.2816 9.9316 3.41435 9.9316 2.34452C9.9316 1.2747 9.1093 0.407453 8.09473 0.407453V0.407227Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90425 0.407227C3.07274 0.407227 3.23587 0.431643 3.39107 0.476408C2.97606 0.978762 2.72419 1.63508 2.72419 2.35379C2.72419 3.07251 2.97113 3.71549 3.37864 4.21603C3.2273 4.25854 3.06845 4.2816 2.90425 4.2816C1.88989 4.2816 1.06738 3.41435 1.06738 2.34452C1.06738 1.2747 1.88968 0.407453 2.90425 0.407453V0.407227Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31998 7.26639C1.31998 6.37427 2.08033 5.81201 2.99029 5.48645C3.20058 5.41116 3.41345 5.34379 3.62909 5.28388C2.74935 5.22306 1.9127 5.35125 1.13092 5.63092C0.514624 5.85135 -0.000488281 6.23229 -0.000488281 6.83661C-0.000488281 7.44093 0.497047 7.85263 1.11505 8.04027C1.2844 8.09159 1.45332 8.13545 1.62159 8.17276C1.43188 7.91412 1.3202 7.61072 1.3202 7.26662L1.31998 7.26639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86803 5.63104C8.98679 5.33374 8.13791 5.22861 7.33105 5.28264C7.55549 5.34233 7.78122 5.40993 8.00865 5.48657C8.92398 5.7954 9.67896 6.37439 9.67896 7.26651C9.67896 7.6079 9.56943 7.91017 9.38272 8.16813C9.55871 8.1297 9.72655 8.08674 9.8839 8.04017C10.5036 7.85704 10.9994 7.4354 10.9994 6.83651C10.9994 6.23761 10.4882 5.83994 9.86803 5.63081V5.63104Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4993 4.68894C6.727 4.68894 7.72224 3.63929 7.72224 2.34447C7.72224 1.04966 6.727 0 5.4993 0C4.27161 0 3.27637 1.04966 3.27637 2.34447C3.27637 3.63929 4.27161 4.68894 5.4993 4.68894Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76637 8.67427C6.60367 9.01814 4.93229 9.19042 3.23218 8.67427C2.57001 8.47329 2.03711 8.02655 2.03711 7.38493C2.03711 6.73765 2.58888 6.32957 3.2489 6.09354C4.6116 5.60589 6.12971 5.5471 7.74922 6.09354C8.41332 6.31759 8.96101 6.73765 8.96101 7.38493C8.96101 8.02632 8.42982 8.47803 7.76594 8.67427H7.76637Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonas);
export default __webpack_public_path__ + "static/media/personas.73f910ef4f896695b4d54a66e0ad4061.svg";
export { ForwardRef as ReactComponent };